const api = "https://app.personeriabqintranet.montierp.com/api/";
//const apiImage = "https://app.personeriabqintranet.montierp.com/storage/"; 3012197026
//const api = "http://127.0.0.1:8000/api/";
const apiImage = "https://documentos2024-aoa.s3.bhs.io.cloud.ovh.net/";
export default api;
export { apiImage };